// import { Navigate, useRoutes } from 'react-router-dom';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
import { PATH_DASHBOARD } from './paths';
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,

  // Dashboard: General
  GeneralAppPage,
  GeneralAnalyticsPage,

  // Dashboard: User
  UserListPage,
  UserEditPage,
  UserCardsPage,
  UserCreatePage,
  UserProfilePage,
  UserAccountPage,
  ProfilePostPage,
  ExplorePage,
  // Dashboard: Blog
  BlogPostsPage,
  BlogPostListPage,
  BlogPostPage,
  BlogNewPostPage,
  BlogEditPostPage,
  Generalhomepage,
  // Dashboard: App
  ChatPage,
  MailPage,
  CalendarPage,
  KanbanPage,
  LogoutPage,
  //
  BlankPage,
  PermissionDeniedPage,
  //
  Page500,
  Page403,
  Page404,
  TncPage,
  PrivacyPolicyPage,
  // HomePage,
  FaqsPage,
  AboutPage,
  Contact,
  ComingSoonPage,
  MaintenancePage,
  UserNotifListing,
  UserActListing,
  UserFileListing,
  Profile,
  ProfileFriends,
  ProfileFollowers,
  ProfileBlog,
  ProfileFavorite,
  ProfileFavoritePost,
  ProfileFavoriteBlog,
  //
} from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Navigate to="/app/home" replace />,
    },
    {
      path: 'user',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        // { path: 'login-unprotected', element: <LoginPage /> },
        // { path: 'register-unprotected', element: <RegisterPage /> },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password/:verifyToken', element: <NewPasswordPage /> },
            // { path: 'new-password/:verifyToken?', element: <NewPasswordPage /> },
            // { path: 'new-password', element: <NewPasswordPage /> },
            { path: 'verify/:verifyToken', element: <VerifyCodePage /> },
            // { path: 'verify/:verifyToken?', element: <VerifyCodePage /> },
            // { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },
    {
      path: '/app',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'home', element: <Navigate to="/app/news/notification" replace /> },
        // { path: 'home', element: <Generalhomepage /> },
        {
          path: 'news',
          element: <Generalhomepage />,
          children: [
            { path: '', element: <UserNotifListing /> },
            { path: 'notification', element: <UserNotifListing /> },
            { path: 'user-activity', element: <UserActListing /> },
            { path: 'user-files', element: <UserFileListing /> },
          ],
        },

        // { path: 'notifications', element: <Notifications /> },
        // { path: 'profile', element: <UserProfile /> },
        // { path: 'setting', element: <UserAccount /> },
        // { path: 'analytics', element: <GeneralAnalyticsPage /> },
        // { path: 'kanban', element: <KanbanPage /> },
        { path: 'explore', element: <ExplorePage /> },
        // { path: 'friends', element: <UserCardsPage /> },
        {
          path: 'profile/:profileEmail',
          element: <UserProfilePage />,
          children: [
            { path: '', element: <Profile /> },
            // { path: 'profile', element: <Profile /> },
            { path: 'following', element: <ProfileFriends /> },
            { path: 'followers', element: <ProfileFollowers /> },
            { path: 'blog', element: <ProfileBlog /> },
            {
              path: 'favorite',
              element: <ProfileFavorite />,
              children: [
                { path: '', element: <ProfileFavoritePost /> },
                { path: 'post', element: <ProfileFavoritePost /> },
                { path: 'blog', element: <ProfileFavoriteBlog /> },
              ],
            },
          ],
        },
        { path: 'profile', element: <UserProfilePage /> },
        { path: 'setting', element: <UserAccountPage /> },

        {
          path: 'post/:postId',
          element: <ProfilePostPage />,
        },
        // { path: 'myposts', element: <BlogPostListPage /> },
        // { path: 'blog', element: <BlogPostsPage /> },
        // { path: 'post', children:{
        // } },
        // { path: 'logout', element: <LogoutPage /> },
        {
          path: 'blog',
          children: [
            { path: '', element: <Navigate to="/blog/explore" replace /> },
            // { element: <Navigate to="/app/community/explore" replace />, index: true },
            // { path: 'list', element: <BlogPostListPage /> },
            { path: 'explore', element: <BlogPostsPage /> },
            // { path: 'new', element: <BlogNewPostPage /> },
            // { path: 'edit/:blogId', element: <BlogEditPostPage /> },
            { path: ':blogId', element: <BlogPostPage /> },
            // { path: '*', element: <Navigate to="/blog/explore" replace /> },
          ],
        },
        // { path: 'blog/explore', element: <BlogPostsPage /> },
        // { path: 'blog/:blogId', element: <BlogPostPage /> },
        {
          path: 'myblog',
          children: [
            { path: '', element: <BlogPostListPage /> },
            // { element: <Navigate to="/app/community/explore" replace />, index: true },
            // { path: 'list', element: <BlogPostListPage /> },
            // { path: 'explore', element: <BlogPostsPage /> },
            { path: 'new', element: <BlogNewPostPage /> },
            { path: 'edit/:blogId', element: <BlogEditPostPage /> },
            // { path: ':blogId', element: <BlogPostPage /> },
          ],
        },

        // {
        //   path: 'community',
        //   children: [
        //     // { element: <Explore />, index: true },
        //     { element: <Navigate to="/app/community/explore" replace />, index: true },
        //     {
        //       path: 'explore',
        //       // element: <Explore />
        //     },
        //   ],
        // },

        // {
        //   path: 'user',
        //   children: [
        //     { element: <Navigate to={PATH_DASHBOARD.general.app} replace />, index: true },

        //   ],
        // },
      ],
    },
    {
      element: (
        <AuthGuard>
          <CompactLayout />
        </AuthGuard>
      ),
      children: [{ path: '/app/logout', element: <LogoutPage /> }],
    },
    // {
    //   element: <MainLayout />,
    //   children: [
    //     // { element: <HomePage />, index: true },
    //     { path: 'about-us', element: <AboutPage /> },
    //     { path: 'contact-us', element: <Contact /> },
    //     { path: 'faqs', element: <FaqsPage /> },
    //   ],
    // },
    {
      element: <CompactLayout />,
      children: [
        // { path: 'coming-soon', element: <ComingSoonPage /> },
        // { path: 'maintenance', element: <MaintenancePage /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
        { path: 'tnc', element: <TncPage /> },
        { path: 'privacy-policy', element: <PrivacyPolicyPage /> },

        // { path: 'logout', element: <LogoutPage /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);

  return <RouterProvider router={router} />;
}
